export function AppFooter() {
  return (
    <footer className="border-t border-slate-200 py-4">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 px-4 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} Statistik</span>
        <span>Analitik ringan · Cloudflare Workers + D1</span>
      </div>
    </footer>
  );
}
